import _ from "lodash";
import moment from "moment";
import $ from "jquery";
import api from "../../services/apiEndpoints";
import { Modal } from "bootstrap";

export const fullcalendarMixin = {
    methods: {
        newMakeEvents(newMakeEvents = false) {
            if (!newMakeEvents && this.numberOfDataFetched !== this.totalNumberOfDataToFetch) {
                return;
            }

            //we have all the data we need at this moment
            let appointments = {};
            let disabledTimes = {};

            //create events based upon the data
            if (
                (this.newCurrentView == "dayGridMonth" ||
                    this.newCurrentView == "timeGridWeek" ||
                    this.newCurrentView == "timeGridThreeDays") &&
                this.showStylistSpecificAppointments
            ) {
                appointments[this.newCurrentStylist.user.id] = !_.isEmpty(
                    this.newAppointments[this.newCurrentStylist.user.id],
                )
                    ? this.newAppointments[this.newCurrentStylist.user.id].slice(0)
                    : [];
                if (this.newCurrentView == "timeGridWeek" || this.newCurrentView == "timeGridThreeDays") {
                    disabledTimes[this.newCurrentStylist.user.id] =
                        this.newDisabledTimes[this.newCurrentStylist.user.id].slice(0);
                }
            } else {
                if (this.newIsGroup || this.groupMemberDisplayAll) {
                    appointments = { ...this.newAppointments };
                    disabledTimes = { ...this.newDisabledTimes };
                } else {
                    appointments[this.user.id] =
                        this.newAppointments[this.user.id] != null ? this.newAppointments[this.user.id].slice(0) : [];
                    disabledTimes[this.user.id] = this.newDisabledTimes[this.user.id].slice(0);
                }
            }

            //refresh the events
            this.newEvents = [];

            let startEndRegister = [];

            // add off-day background events
            const calendarApi = this.getFullCalendarApi();
            if (!calendarApi) return;

            const view = calendarApi.view;

            const viewType = view.type;
            // MULTI-RESOURCE SUPPORT
            if (viewType === "resourceTimeGridDay") {
                const users = this.newIsGroup || this.groupMemberDisplayAll ? this.newUsers : [this.newCurrentStylist];

                users.forEach((user) => {
                    if (!user) return;

                    const offDayEvents = this.createDayOffBackgroundEvents(user, view.activeStart, view.activeEnd);

                    const resourceId = user.id || user.user?.id;

                    offDayEvents.forEach((event) => {
                        event.resourceId = resourceId;
                    });

                    this.newEvents.push(...offDayEvents);
                });
            } else if (this.showStylistSpecificAppointments && this.newCurrentStylist) {
                const offDayEvents = this.createDayOffBackgroundEvents(
                    this.newCurrentStylist,
                    view.activeStart,
                    view.activeEnd,
                );

                this.newEvents.push(...offDayEvents);
            }

            //merge disabledTimes to appointments
            _.each(disabledTimes, (disabledTimeObjects, userId) => {
                let insertDisabledTimeObjects = [];
                disabledTimeObjects.forEach((disabledTimeObject) => {
                    if (disabledTimeObject.start == disabledTimeObject.end) {
                        return;
                    }
                    let startEndRegisterEntry = disabledTimeObject.start + "-" + disabledTimeObject.end + "-" + userId;
                    if (startEndRegister.indexOf(startEndRegisterEntry) != -1) {
                        return;
                    }
                    startEndRegister.push(startEndRegisterEntry);
                    insertDisabledTimeObjects.push(disabledTimeObject);
                });

                appointments[userId] = !_.isEmpty(appointments[userId])
                    ? appointments[userId].concat(insertDisabledTimeObjects)
                    : insertDisabledTimeObjects;
            });

            _.each(appointments, (appts, userId) => {
                appts.forEach((el) => {
                    if (el.status == "canceled") {
                        return;
                    }

                    el.user_id = userId;
                    //add services in the week and daily view (will be in monthly view too but wont be visible because of the space)
                    if (typeof el.services == "string" && el.services) {
                        el.services_array = el.services.split(";");
                    } else {
                        el.services_array = [];
                    }
                    el.showServices = el.services_array.join(", ");

                    let eventObject = this.newGetEventObject(el);
                    this.newEvents.push(eventObject);

                    //make pause event
                    let pauseEventObject = this.newGetPauseEventObject(eventObject);
                    if (pauseEventObject) {
                        this.newEvents.push(pauseEventObject);
                    }

                    //the loading on refresh button
                    this.loading = false;
                });
            });

            this.calendarOptions.events = this.newEvents;

            this.initialDetailsFetched = true;

            this.loadingView = false;
        },
        newGetEventObject(el) {
            if (el.type === "disabledTime") {
                let eventObject = {
                    id: `disabled-${el.start}-${el.user_id}`,
                    start: moment(el.start).toISOString(),
                    end: moment(el.end).toISOString(),
                    display: "background",
                    backgroundColor: "#d3d3d3",
                    overlap: false,
                    type: "disabledTime",
                };

                if (this.newIsGroup || this.groupMemberDisplayAll) {
                    eventObject.resourceId = el.user_id;
                }

                return eventObject;
            }

            let duration = el.duration ? el.duration : 15;
            let endDate = moment(el.date).add(duration, "minutes");
            let start = moment(el.date).format("hh:mm A");
            let end = endDate.format("hh:mm A");
            el.end_date = endDate.format("YYYY-MM-DD HH:mm:ss");
            el.start = start;
            el.end = end;

            let eventObject = {
                id: el.id,
                start: el.date,
                end: el.end_date,
                title: el.with_name + " - From: " + start + " To: " + end + " " + el.showServices,
                backgroundColor: "#e0e0f0",
                textColor: "#000000",
                user_id: el.user_id,
                prevent_clients_reschedule: el.prevent_clients_reschedule,
                status: el.status,
                cancel_details: el.cancel_details,
                className: "",
            };

            if (this.newCurrentView == "resourceTimeGridDay" || this.newCurrentView == "resourceTimeGridDay") {
                eventObject["borderColor"] = this.memberColors[el.user_id];
                eventObject["className"] += " eventCustomClass";
            }

            if (typeof el.recurring !== "undefined" && el.recurring == 1) {
                eventObject["className"] += " recurringEvent";
                eventObject["recurring"] = 1;
            }

            const calendarApi = this.getFullCalendarApi();

            if (calendarApi && calendarApi.view.type === "resourceTimeGridDay") {
                eventObject.resourceId = el.user_id;
                eventObject.constraint = {
                    resourceIds: [el.user_id],
                };
            }
            
            if (el.services_ids == null) {
                return eventObject;
            }

            var targetColorCode = "000000";

            //Get the event color from service
            if (el.services_colors != null) {
                let targetServiceColor = el.services_colors.split(";");
                targetColorCode = targetServiceColor[0];
            }

            if (typeof targetColorCode !== "undefined" && targetColorCode !== null) {
                eventObject["backgroundColor"] = "#" + targetColorCode;
                eventObject["textColor"] = "#ffffff";
            }
            return eventObject;
        },

        newGetPauseEventObject(eventObject) {
            const pauseMinutes = this.newPauseBetweenAppointments[eventObject.user_id];

            if (pauseMinutes <= 0 || eventObject.type === "disabledTime") {
                return null;
            }

            const start = new Date(eventObject.end);

            const end = new Date(start.getTime() + pauseMinutes * 60000);

            const pauseEventObject = {
                id: `pause-${eventObject.id || Math.random()}`,
                start: start.toISOString(),
                end: end.toISOString(),
                display: "background",
                // backgroundColor: "#d0d0d0",
                className: "fc-bg-break",
                overlap: false,
                extendedProps: {
                    user_id: eventObject.user_id,
                },
            };

            if (this.newIsGroup || this.groupMemberDisplayAll) {
                pauseEventObject.resourceId = eventObject.user_id;
            }

            return pauseEventObject;
        },
        newGetDisabledTimes(user) {
            if (user == null) {
                return;
            }

            let userId = user.user.id;
            this.newDisabledTimes[userId] = [];

            //4 things to manage here, this function will be responsible for
            //showing the grey area on the calendar

            //free_days and free_days_time
            let objectsFreeTime = this.newManageFreeTime(user);
            if (objectsFreeTime && objectsFreeTime.length) {
                objectsFreeTime.forEach((object) => {
                    this.newDisabledTimes[userId].push(object);
                });
            }

            //get_stylist_free_hours to make before and after the business hour time area as grey - only http request here
            let activeDateRange;

            if (this.user && this.user.role === "client") {
                activeDateRange = {
                    start: new Date(),
                    end: moment().add(7, "days").toDate(),
                };
            } else {
                const calendarApi = this.getFullCalendarApi();
                if (!calendarApi) return;
                const view = calendarApi.view;

                activeDateRange = {
                    start: view.currentStart,
                    end: view.currentEnd,
                };
            }

            let datesArray = this.newGetDates(activeDateRange.start, activeDateRange.end);
            let startBusinessHour = 23;

            let currentStartHour = this.calendarOptions.slotMinTime;

            datesArray.forEach((date, index) => {
                let formattedDate = date;
                let dateForBusinessHours = moment(formattedDate + "T00:00:00").toDate();
                let businessDayIndex = dateForBusinessHours.getDay();
                let objectBusinessHours = this.newManageBusinessHours(date, businessDayIndex, userId);
                if (objectBusinessHours) {
                    this.newDisabledTimes[userId] = this.newDisabledTimes[userId].concat(objectBusinessHours);
                }

                //make break hours grey area data (newDisabledTimes)
                let dateForBreak = moment(formattedDate + "T00:00:00").toDate();
                let dayIndex = dateForBreak.getDay();
                let objectBreakHours = this.newManageBreakHours(formattedDate, dayIndex, userId);
                if (objectBreakHours) {
                    this.newDisabledTimes[userId].push(objectBreakHours);
                }
                if (index === datesArray.length - 1) {
                    this.numberOfDataFetched++;
                    this.newMakeEvents();
                }

                if (this.newBusinessHours[userId] && this.newBusinessHours[userId][dayIndex]) {
                    let startHourArr = this.newBusinessHours[userId][dayIndex]["start"].split(":");
                    let startHour = parseInt(startHourArr[0]) - 2;

                    if (startHour < startBusinessHour) {
                        startBusinessHour = startHour;
                        currentStartHour =
                            this.zeroPadNum(startHour, 2) + ":" + startHourArr[1] + ":" + startHourArr[2];
                    }
                }
            });

            this.calendarOptions.slotMinTime = currentStartHour;

            //Disable week days
            this.createDayOffBackgroundEvents;

            return;
        },

        createDayOffBackgroundEvents(user, viewStart, viewEnd) {
            const events = [];
            if (!user || !user.work_settings) return events;

            const dayMap = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
            let current = moment(viewStart).startOf("day");
            const end = moment(viewEnd);

            while (current.isBefore(end)) {
                const dateStr = current.format("YYYY-MM-DD");
                const dayKey = dayMap[current.day()];
                const settings = user.work_settings;

                const isWorkingDay = settings[dayKey] === 1; // e.g., tuesday: 1
                const isException = user.exception_days?.includes(dateStr); // Work when usually off
                const isFreeDay = user.free_days?.includes(dateStr); // Off when usually work

                // --- Exception day (highlight differently) ---
                if (isException) {
                    events.push({
                        start: dateStr,
                        end: current.clone().add(1, "days").format("YYYY-MM-DD"),
                        display: "background",
                        className: "fc-bg-exception",
                        extendedProps: { disabled: false },
                        resourceId: user.user.id,
                    });
                }
                // --- Non-working day (weekly off or forced free day) ---
                else if (!isWorkingDay || isFreeDay) {
                    events.push({
                        start: dateStr,
                        end: current.clone().add(1, "days").format("YYYY-MM-DD"),
                        display: "background",
                        className: isFreeDay ? "fc-bg-free-day" : "fc-bg-blocked",
                        extendedProps: { disabled: true },
                        resourceId: user.user.id,
                    });
                }
                // --- Working day (gray out non-working hours and lunch break) ---
                else {
                    const startWork = this.formatTimeTo24(settings[`${dayKey}_from`]);
                    const endWork = this.formatTimeTo24(settings[`${dayKey}_to`]);

                    // Block: Midnight to Start of Work
                    if (startWork && startWork !== "00:00:00") {
                        events.push({
                            start: `${dateStr}T00:00:00`,
                            end: `${dateStr}T${startWork}`,
                            display: "background",
                            className: "fc-bg-blocked",
                            resourceId: user.user.id,
                        });
                    }

                    // Block: End of Work to Midnight
                    if (endWork && endWork !== "23:59:59") {
                        events.push({
                            start: `${dateStr}T${endWork}`,
                            end: `${dateStr}T23:59:59`,
                            display: "background",
                            className: "fc-bg-blocked",
                            resourceId: user.user.id,
                        });
                    }

                    // Optional: Lunch break
                    const breakStart = this.formatTimeTo24(settings[`${dayKey}_block_from`]);
                    const breakEnd = this.formatTimeTo24(settings[`${dayKey}_block_to`]);
                    if (breakStart && breakEnd) {
                        events.push({
                            start: `${dateStr}T${breakStart}`,
                            end: `${dateStr}T${breakEnd}`,
                            display: "background",
                            className: "fc-bg-break",
                            resourceId: user.user.id,
                        });
                    }
                }

                current.add(1, "days");
            }

            return events;
        },

        formatTimeTo24(timeString) {
            if (!timeString) return null;
            return moment(timeString, ["h:mm A"]).format("HH:mm:ss");
        },
        getFullCalendarApi() {
            const calendar = this.$refs?.fullCalendar;
            if (!calendar || typeof calendar.getApi !== "function") {
                return null;
            }
            return calendar.getApi();
        },

        setInitialCalendarOptions() {
            if (this.bookData?.date) {
                this.calendarOptions.initialDate = this.bookData.date;
            }
        },

        getFullCalendarApi() {
            if (this.$refs.fullCalendar) {
                return this.$refs.fullCalendar.getApi();
            }
            return null;
        },

        handleDateChange(direction) {
            if (!this.calendarApptsReady) return;

            const isMonthView = this.newCurrentView === "dayGridMonth";

            let newDate = moment(this.newCurrentDate)
                .add(direction, isMonthView ? "M" : "days")
                .startOf(isMonthView ? "month" : "day")
                .format("YYYY-MM-DD");

            this.newCurrentDate = newDate;
            this.bookData.date = newDate;

            this.$nextTick(() => {
                const api = this.getFullCalendarApi();
                if (!api) return;

                api.gotoDate(newDate);
                this.currentDayNumber = this.getDayNumber();
            });

            const stylistId = this.showStylistSpecificAppointments ? this.newCurrentStylistId : 0;

            this.filterMemberDisplayed(stylistId);
        },

        handleNextButtonClick() {
            this.handleDateChange(1);
        },

        handlePrevButtonClick() {
            this.handleDateChange(-1);
        },

        handleTodayButtonClick() {
            if (this.calendarApptsReady == false) {
                return;
            }

            this.getFullCalendarApi().today();

            if (this.newCurrentView === "timeGridWeek") {
                this.$nextTick(() => {
                    this.newCurrentDate = moment().format("YYYY-MM-DD");
                    this.bookData.date = this.newCurrentDate;
                    this.currentDayNumber = this.getDayNumber();
                });
            }

            this.saveCalendarView(this.calendarViews.DAY);

            if (!this.showStylistSpecificAppointments) {
                this.filterMemberDisplayed(0);
            } else {
                this.filterMemberDisplayed(this.newCurrentStylistId);
            }
        },

        handleMonthButtonClick() {
            if (!this.calendarApptsReady) return;

            // Update the current date
            this.newCurrentDate = moment().format("YYYY-MM-DD");
            this.bookData.date = this.newCurrentDate;

            // Wait for DOM / calendar component to be ready
            this.$nextTick(() => {
                const calendarApi = this.getFullCalendarApi();
                if (calendarApi) {
                    // Go to the current date and switch to month view
                    calendarApi.gotoDate(this.newCurrentDate);
                    calendarApi.changeView("dayGridMonth");
                }

                // Update the current day number after API is ready
                this.currentDayNumber = this.getDayNumber();
            });

            // Save the current calendar view
            this.saveCalendarView(this.calendarViews.MONTH);
        },

        handleWeekButtonClick() {
            if (this.calendarApptsReady === false) {
                return;
            }

            this.newCurrentDate = moment().format("YYYY-MM-DD");
            this.bookData.date = this.newCurrentDate;

            this.$nextTick(() => {
                const calendarApi = this.getFullCalendarApi();
                if (!calendarApi) return;

                calendarApi.gotoDate(this.newCurrentDate);
                calendarApi.changeView("timeGridWeek", this.newCurrentDate);

                this.currentDayNumber = this.getDayNumber();
            });

            this.saveCalendarView(this.calendarViews.WEEK);
        },

        handleThreeDaysButtonClick() {
            if (this.calendarApptsReady == false) {
                return;
            }

            this.$nextTick(() => {
                this.getFullCalendarApi().gotoDate(this.newCurrentDate);
                this.threeDaysView(this.newCurrentDate);

                this.newCurrentDate = moment().format("YYYY-MM-DD");
                this.bookData.date = this.newCurrentDate;
                this.getFullCalendarApi().gotoDate(this.newCurrentDate);
                this.threeDaysView(this.newCurrentDate);
                this.currentDayNumber = this.getDayNumber();
            });

            this.saveCalendarView(this.calendarViews.THREE_DAYS);
        },

        handleDayButtonClick() {
            if (this.calendarApptsReady == false) {
                return;
            }

            this.$nextTick(() => {
                const calendarApi = this.getFullCalendarApi();
                if (!calendarApi) return;

                calendarApi.gotoDate(this.newCurrentDate);
                calendarApi.changeView("resourceTimeGridDay", this.newCurrentDate);
                this.saveCalendarView(this.calendarViews.DAY);

                // moved logic from setTimeout into nextTick
                this.newCurrentDate = moment().format("YYYY-MM-DD");
                this.bookData.date = this.newCurrentDate;
                calendarApi.gotoDate(this.newCurrentDate);
                this.currentDayNumber = this.getDayNumber();
            });

            if (!this.showStylistSpecificAppointments) {
                this.filterMemberDisplayed(0);
            } else {
                this.filterMemberDisplayed(this.newCurrentStylistId);
            }
        },

        getDayNumber() {
            const date = moment(this.newCurrentDate);
            return date.day();
        },

        threeDaysView(date) {
            let endDay = moment(date).add(3, "days").format("YYYY-MM-DD");

            this.getFullCalendarApi().changeView("timeGridThreeDays", {
                start: date,
                end: endDay,
            });
        },

        attachCalendarTitleClick() {
            const calendarComponent = this.$refs.fullCalendar;

            if (!calendarComponent) return;
            if (!calendarComponent.$el) return;

            const titleEl = calendarComponent.$el.querySelector(".fc-toolbar-title");

            if (!titleEl) return;

            titleEl.style.cursor = "pointer";

            // prevent duplicate listeners
            titleEl.onclick = () => {
                this.toggleDatePicker();
            };
        },

        renderUserHeader(arg) {
            if (!arg?.resource) {
                return;
            }

            if (this.currentView === "resourceTimeGridDay" && !this.showStylistSpecificAppointments) {
                return;
            }

            const user = arg.resource.extendedProps;
            const hasImage = !!user?.imageurl;

            return {
                html: `
                <div class="center-table-head">
                    ${
                        hasImage
                            ? `<img
                        class="stylist-avatar calendar-avatar"
                        src="${user.imageurl}"
                        onerror="this.remove()"
                        />`
                            : ""
                    }
                    <span>${arg.resource.title}</span>
                </div>
                `,
            };
        },

        newOnDateClick(arg, noResetTime = false) {
            this.newShowTimeSpinner = true;
            this.bookData.personal = false;

            let type = localStorage.getItem("calendarView");
            if (typeof arg.view !== "undefined" && typeof arg.view.type !== "undefined") {
                type = arg.view.type;
            }
            if (typeof type == "undefined") {
                type = "dayGridMonth";
            }

            if (
                (this.newIsGroup || this.groupMemberDisplayAll) &&
                (type == "resourceTimeGridDay" || type == "resourceTimeGridDay")
            ) {
                if (typeof arg.resource !== "undefined" && typeof arg.resource.id !== "undefined") {
                    this.newCurrentStylistId = arg.resource.id;
                    this.newCurrentStylist = this.newUsers.find((user) => user.user.id == this.newCurrentStylistId);

                    this.newPagedClients = this.newClients[this.newCurrentStylistId];
                    this.newPage[this.newCurrentStylistId] = 2;
                    this.newLoadMore[this.newCurrentStylistId] = this.originalLoadMore[this.newCurrentStylistId];
                }
            }

            let date = arg.date;
            this.bookData.date = date;
            this.day = moment(date).format("ddd");
            this.date = moment(date).format("l");

            if (!noResetTime) {
                this.hour = moment(date).format("hh:mm A");
            }

            //get the time array to show the time dropdown for the clicked date
            let currentDatetime = moment().format("YYYY-MM-DD h:mm a");
            let currentDate = moment(this.bookData.date).format("YYYY-MM-DD");
            let query =
                "?include_taken=1&stylist_id=" +
                this.newCurrentStylistId +
                "&date=" +
                currentDate +
                "&current_datetime=" +
                currentDatetime;
            this.$http.get(api.actions.get_stylist_free_hours + query).then((response) => {
                if (typeof response.data.free_hours != "undefined") {
                    this.newTimeArray = this.newProcessMakeTimeResponse(response);

                    let missingTimeArray = this.fillInMissingTimes(
                        this.newTimeArray[0],
                        this.newTimeArray[this.newTimeArray.length - 1],
                    );

                    this.newTimeArray = this.newTimeArray.concat(missingTimeArray);
                    this.newTimeArray.sort(function (obj1, obj2) {
                        return obj1.date - obj2.date;
                    });

                    //get the closest hour to be the selected one
                    let allFormattedTime = [];
                    this.newTimeArray.forEach(function (element) {
                        allFormattedTime.push(element.date);
                    });

                    this.newShowTimeSpinner = false;
                }
            });

            let selectedDate = moment(date);
            if (this.user.role == "client" && moment().diff(selectedDate, "days") > 0) {
                return;
            }

            if (this.user.role !== "client") {
                if (!this.eventModalIsOpened) {
                    const dateModalEl = document.getElementById("date-modal");
                    const dateModalInstance = Modal.getInstance(dateModalEl) || new Modal(dateModalEl);
                    if (dateModalInstance) {
                        dateModalInstance.show();
                    }
                }
            } else {
                this.$router.push("/app/stylists");
            }

            return;
        },

        newOnDateClickFromFullCalendarDatePicker(date) {
            this.newCurrentDate = moment(date).format("YYYY-MM-DD");
            this.newShowFullCalendarDatePicker = false;
            this.bookData.date = date;
            this.getFullCalendarApi().gotoDate(date);
            this.showCalendarDateChoosePopup = false;
            this.secondaryDatepickerDate = this.addTimeToDate(this.bookData.date, 1, "M");

            if (this.newCurrentView == "timeGridWeek") {
                setTimeout(() => {
                    this.newCurrentDate = moment(date).format("YYYY-MM-DD");
                    this.bookData.date = this.newCurrentDate;
                    this.getFullCalendarApi().gotoDate(this.newCurrentDate);
                }, 50);
            }
        },

        onDateClickFromFullCalendarDatePicker(date) {
            this.newShowFullCalendarDatePicker = false;
            this.getFullCalendarApi().gotoDate(date);
        },

        resourceLabelContent(arg) {
            const resourceId = arg.resource.id;
            const memberColor = this.memberColors[resourceId];
            const imageUrl = arg.resource.extendedProps?.imageurl;

            // Container
            const wrapper = document.createElement("div");
            wrapper.style.display = "flex";
            wrapper.style.alignItems = "center";
            wrapper.style.gap = "6px";
            wrapper.style.justifyContent = "center";

            // Avatar (only if exists)
            if (imageUrl) {
                const img = document.createElement("img");
                img.src = imageUrl;
                img.className = "stylist-avatar calendar-avatar";
                wrapper.appendChild(img);
            }

            // Text
            const span = document.createElement("span");
            span.textContent = arg.resource.title;

            if (memberColor) {
                span.style.color = memberColor;
                span.style.outline = `1px solid ${memberColor}`;
                span.style.padding = "2px 4px";
                span.style.borderRadius = "4px";
            }

            wrapper.appendChild(span);

            return { domNodes: [wrapper] };
        },

        setDateLabelPos() {
            var toolbarWidth = $(".fc-toolbar.fc-header-toolbar .fc-center").width();
            var toolbarCenterWidth = $(".fc-toolbar.fc-header-toolbar").width();
            this.dayBeforeDateRight = ((toolbarCenterWidth / 2 + toolbarWidth / 2 + 15) / toolbarCenterWidth) * 100;
        },
    },
};
